import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UIContext } from '../../context/UIContext'
import { useTranslation } from 'react-i18next'

const Step3View = (props) => {
    const { t } = useTranslation(['wizard'])

    const {
        subjectName,
        suggestedSubjects,
        onClickSubject,
        subjectSelected,
        isNextStepEnabled,
        isSearching,
        onSubmit,
        onInputChange,
    } = props

    const { titleCaseFn } = useContext(UIContext)

    const [buttonLabel, setButtonLabel] = useState(t('wizard:next'))

    useEffect(() => {
        if (!!subjectName && subjectSelected === null) {
            setButtonLabel(t('wizard:create'))
        } else if (subjectName && subjectSelected) {
            setButtonLabel(t('wizard:join'))
        } else {
            setButtonLabel(t('wizard:next'))
        }
    }, [subjectName, subjectSelected, t])

    return (
        <div className="step-container responsive">
            <div className="onboarding-img step2"></div>
            <div className="onboarding-form">
                <div className="info">
                    <span className="step-label">{t('wizard:step')} 3/5</span>
                    <span className="step-title">{t('wizard:step3.title')}</span>
                    <p className="global-text">{t('wizard:step3.desc')}</p>
                </div>
                <form id="recomendations" onSubmit={onSubmit}>
                    <div className="recomendation-container">
                        <div>
                            <input
                                autoFocus
                                type="text"
                                value={titleCaseFn(subjectName)}
                                placeholder={t('wizard:step2.input')}
                                onChange={(e) => onInputChange(e.target.value)}
                                className="form-input"
                            />
                            {isSearching && (
                                <span className="loading-span">
                                    <FontAwesomeIcon icon={['fa', 'spinner']} spin size="1x" />
                                </span>
                            )}
                        </div>
                        {suggestedSubjects.length > 0 ? (
                            <div
                                className="egg-list egg-card recomendations-list"
                                style={{
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    marginTop: '-10px',
                                }}
                            >
                                {suggestedSubjects.map((subject) => {
                                    return (
                                        <div
                                            key={subject._id}
                                            className="list-item clickeable-item"
                                            onClick={onClickSubject(subject)}
                                        >
                                            {titleCaseFn(subject.name)}
                                        </div>
                                    )
                                })}
                            </div>
                        ) : null}
                    </div>
                </form>
                <button
                    form="recomendations"
                    type="submit"
                    className="btn-next-wizard"
                    disabled={!isNextStepEnabled}
                >
                    {buttonLabel}
                </button>
            </div>
        </div>
    )
}

Step3View.propTypes = {
    subjectName: PropTypes.string.isRequired,
    onClickSubject: PropTypes.func.isRequired,
    suggestedSubjects: PropTypes.array.isRequired,
    subjectSelected: PropTypes.string,
    isNextStepEnabled: PropTypes.bool,
    isSearching: PropTypes.bool,
    onSubmit: PropTypes.func,
    onInputChange: PropTypes.func,
}

export default Step3View
